import React, { useEffect, useContext, useMemo } from "react";
import { CreateUseCaseContext, CreateUseCaseProvider } from "../../../store";
import "./case-assistant.page.scoped.scss";
import ChatbotComponent from "../../../modules/case-assistant/components/chatbot/chatbot.component";
import { LookupsService } from "../../../services/lookups/lookups.service";
import { CASES_PAGE_TYPES, ROLES } from "../../../modules/case/types/AI-roles";
import { history } from "react-router-guard";
import { RiskLevelsService } from "../../../services/riskLevels.services";
import { ProductsService } from "../../../services/products.services";
import { CaseRole } from "../../../types/case";

// Separate component that fetches data and renders the chatbot
const CaseAssistantContent = (props: any) => {
  const { role } = props;

  const {
    setRiskLevels,
    setProducts,
    setCaseRoles,
    setLands,
    setBranches,
    setAreas,
    setOperations,
    setAlgorithms,
    setTechniques,
    setMachineLearningTypes,
    setRole,
  } = useContext(CreateUseCaseContext);

  const lookupsService = new LookupsService();
  const riskLevelsService = new RiskLevelsService();
  const productsService = new ProductsService();

  // Determine allowed roles based on page type
  const allowedRoles = useMemo(() => {
    if (role.includes(CASES_PAGE_TYPES.DEVELPMENT)) {
      setRole([ROLES.PROVIDER, ROLES.DEPLOYER]);
      return [ROLES.PROVIDER, ROLES.DEPLOYER];
    } else if (role.includes(CASES_PAGE_TYPES.DEMAND)) {
      setRole([
        ROLES.IMPORTER,
        ROLES.DISTRIBUTER,
        ROLES.AUTHORISED_REPRESENTATIVE,
        ROLES.DATA_SUBJECT,
      ]);
      return [
        ROLES.IMPORTER,
        ROLES.DISTRIBUTER,
        ROLES.AUTHORISED_REPRESENTATIVE,
        ROLES.DATA_SUBJECT,
      ];
    }
    return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          riskLevels,
          products,
          caseRoles,
          lands,
          branches,
          areas,
          operations,
          algorithms,
          techniques,
          machineLearningTypes,
        ] = await Promise.all([
          riskLevelsService.list(),
          productsService.list(),
          lookupsService.listCaseRoles(),
          lookupsService.listLands(),
          lookupsService.listBranches(),
          lookupsService.listAIAreas(),
          lookupsService.listOperation(),
          lookupsService.listAIAlgorithms(),
          lookupsService.listAITechniques(),
          lookupsService.listMachineLearningTypes(),
        ]);

        setRiskLevels(riskLevels);
        setProducts(products);
        setLands(lands);
        setBranches(branches);
        setAreas(areas);
        setOperations(operations);
        setAlgorithms(algorithms);
        setTechniques(techniques);
        setMachineLearningTypes(machineLearningTypes);

        // Filter caseRoles based on allowed roles (matching by slug)
        const filteredCaseRoles = caseRoles.filter((caseRole: CaseRole) => {
          if (!caseRole.slug || allowedRoles.length === 0) {
            return false;
          }
          // Match caseRole.slug (case-insensitive) with any of the allowed roles
          const roleSlug = caseRole.slug.toUpperCase();
          return allowedRoles.some(
            (allowedRole) => allowedRole.toUpperCase() === roleSlug
          );
        });

        setCaseRoles(filteredCaseRoles);
      } catch (error) {
        console.error("Error fetching lookup data:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowedRoles]);

  useEffect(() => {
    // Validate query params first
    if (
      role !== `?role=${CASES_PAGE_TYPES.DEVELPMENT}` &&
      role !== `?role=${CASES_PAGE_TYPES.DEMAND}`
    ) {
      history.push(`/dashboard`);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ChatbotComponent />;
};

const CaseAssistantPage = (props: any) => {
  return (
    <CreateUseCaseProvider>
      <CaseAssistantContent role={props.location.search} />
    </CreateUseCaseProvider>
  );
};

export default CaseAssistantPage;
